import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Form, Modal, Container, Row, Col } from "react-bootstrap";

import './CdGateModal.scss';

import messages from "../../assets/i18n";
import ButtonStandard from "../ButtonStandard/ButtonStandard";
import CdHours from "../CdHours/CdHours";
import Switch from "../Switch/Switch";

function CdGateModal(props) {

	const lang = useSelector(state => state.language.name);
	const cdGateValidCapacidadeForm =  useSelector(state => state.cdGates.cdGateValidCapacidadeForm);
	const cdGateValidIntervaloForm =  useSelector(state => state.cdGates.cdGateValidIntervaloForm);
	const hours = props.gate.horarios.sort( ( prev, next ) => {
		return prev.idDiaSemana < next.idDiaSemana ? -1 : prev.idDiaSemana > next.idDiaSemana ? 1 : 0;
	});

	const dispatch = useDispatch();

	const cdId = useSelector(state => state.cdDetails.cdSelect);

	const [dynamicCapacityEnable, setDynamicCapacityEnable] = React.useState(props.gate.capacidadeDinamica);

	useEffect(() => {
		dispatch({
			type: "SET_ID_CD_GATE",
			payload: {
				idCd: cdId
			}
		});
		// eslint-disable-next-line
	}, [cdId]);

	useEffect(() => {
		setDynamicCapacityEnable(props.gate.capacidadeDinamica)
	}, [props.gate.capacidadeDinamica]);
	
	const handleNameGate = (nome) => {
		dispatch({
			type: "SET_NOME_GATE",
			payload: {
				nome
			}
		});
	}

	const dispatchGate = (actionType) => {
		if(actionType === 'create'){
			dispatch({
				type: "SAVE_CD_GATE",
				data: {...props.gate, idCd: cdId }
			});	
		} else {
			dispatch({
				type: "UPDATE_CD_GATE",
				data: {...props.gate, idCd: cdId }
			});
		}
		props.onHide(false);
	}

	const handleDynamicCapacity = (capacidadeDinamica) => {
		setDynamicCapacityEnable(capacidadeDinamica);
		dispatch({
			type: "SET_CAPACIDADE_DINAMICA",
			payload: {
				capacidadeDinamica
			}
		});
	}

	return (
		<Modal
			{...props}
			aria-labelledby="contained-modal-title-vcenter"
			className="cd-gate-modal"
			centered
		>
			<Modal.Header className="text-left" closeButton>
				<Modal.Title className="font-weight-bold">
					{props.title}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Container className="px-0 mb-5 pb-5">
					<Row>
						<Col>

							<Switch 
								name={messages[lang].dynamicCapacity} 
								checked={props.gate.capacidadeDinamica}
								onChange={e => handleDynamicCapacity(e.target.checked)}
							/>

							<Form.Group bsPrefix={"form-group-custom"} >
								<Form.Label>{messages[lang].gate}:</Form.Label>
								<Form.Control 
									type="text"
									value={props.name}
									maxLength={50}
									onChange={e => handleNameGate(e.target.value)} 
									placeholder={messages[lang].textEnterTheGateName} />
							</Form.Group>

							<CdHours action={props.type} type={"gate"} hours={hours} resetHours={props.resetHours} dynamicCapacity={dynamicCapacityEnable}/>

						</Col>
					</Row>
				</Container>

			</Modal.Body>
			<Modal.Footer>
				<ButtonStandard
					id="load_modal_add_order_button"
					text={messages[lang].save}
					textClass="text-3"
					disabled={props.name.trim().length <= 0 || cdGateValidCapacidadeForm === false || cdGateValidIntervaloForm === false}
					//isLoading={this.state.buttonLoading}
					className="btn btn-primary btn-standard px-4 py-1"
					onClick={() => dispatchGate(props.type)}
				/>
			</Modal.Footer>
		</Modal>
	)
}

export default CdGateModal;